// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M14.9996 2.71706C13.2435 1.56387 10.8296 1.75582 9.29248 3.29289C8.33207 4.2533 7.88892 5.55643 7.97647 6.824L2.0726 19.291L2.06524 19.3082C1.35405 20.9677 3.03193 22.6455 4.69137 21.9343L4.70855 21.927L17.1756 16.0231C18.4432 16.1107 19.7463 15.6675 20.7067 14.7071C22.2438 13.17 22.4357 10.7561 21.2825 9.00001C22.4357 7.24393 22.2438 4.82996 20.7067 3.29289C19.1696 1.75582 16.7557 1.56387 14.9996 2.71706ZM16.4142 4.21327C17.3546 3.77683 18.5268 3.94144 19.2925 4.7071C20.2678 5.68246 20.2678 7.31754 19.2925 8.2929C18.5268 9.05856 17.3546 9.22317 16.4141 8.78673C17.2273 7.38246 17.2273 5.61753 16.4142 4.21327ZM19.7863 10.4146C20.2228 11.355 20.0581 12.5272 19.2925 13.2929C18.7924 13.793 18.1192 14.0451 17.4475 14.0337L9.96589 6.55208C9.95447 5.88041 10.2066 5.2072 10.7067 4.7071C11.6821 3.73175 13.3171 3.73175 14.2925 4.7071C15.2678 5.68246 15.2678 7.31753 14.2925 8.29289L13.5854 9L14.2925 9.7071C15.7682 11.1828 18.0523 11.4187 19.7863 10.4146Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-ice-cream-filled')
export default class IceCreamFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ice-cream-filled',
    }
  }
}
